import axios from "axios";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { MdDownloadForOffline } from "react-icons/md";
import exportToExcel from "../../utils/exportToExcel";
import InmateReport from "../../components/AdminSideComponents/ReportSection/InmateReport";
import AvailabilityReport from "../../components/AdminSideComponents/ReportSection/AvailabilityReport";
import ExpenseReport from "../../components/AdminSideComponents/ReportSection/ExpenseReport";
import IssueReport from "../../components/AdminSideComponents/ReportSection/IssueReport";
import PaymentsReport from "../../components/AdminSideComponents/ReportSection/PaymentsReport";
import CheckOutReport from "../../components/AdminSideComponents/ReportSection/CheckOutReport";

const Reports = () => {
  const [loading, setLoading] = useState(false);

  const [reportType, setReportType] = useState("Inmate Report");
  const [inmateReport, setInmateReport] = useState([]);
  const [availabilityReport, setAvailabilityReport] = useState([]);
  const [financialYear, setFinancialYear] = useState("");
  const [expenseReport, setExpenseReport] = useState([]);
  const [issueReport, setIssueReport] = useState([]);
  const [paymentsReport, setPaymentsReport] = useState([]);
  const [profitLossReport, setProfitLossReport] = useState([]);
  const [checkOutReport, setCheckOutReport] = useState([]);

  //Function to get inmate report
  const getInmateReport = () => {
    setLoading(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/report/get-inmates-report`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of getInmateReport: ", response.data);
        setInmateReport(response.data.data);
        setLoading(false);
        toast.success("Inmate Report generated successfully");
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  //Function to get inmate report
  const getAvailabilityReport = () => {
    setLoading(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/report/get-availability-report`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of getAvailabilityReport: ", response.data);
        setAvailabilityReport(response.data);
        setLoading(false);
        toast.success("Availability Report generated successfully");
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  //Function to get expense report
  const getExpenseReport = () => {
    setLoading(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/report/get-expense-report`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of getExpenseReport: ", response.data);
        setExpenseReport(response.data.data);
        setFinancialYear(response.data.financialYear);
        setLoading(false);
        toast.success("Expense Report generated successfully");
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  //Function to get issue report
  const getIssueReport = () => {
    setLoading(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/report/get-issue-report`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of getIssueReport: ", response.data);
        setIssueReport(response.data.data);

        setLoading(false);
        toast.success("Expense Report generated successfully");
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  //Function to get payments report
  const getPaymentsReport = () => {
    setLoading(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/report/get-payments-report`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of getPaymentsReport: ", response.data);
        setPaymentsReport(response.data);
        setLoading(false);
        toast.success("Payments Report generated successfully");
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  //Function to get payments report
  const getProfitLossReport = () => {
    setLoading(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/report/get-profitOrLoss-report`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of getPaymentsReport: ", response.data);
        setProfitLossReport(response.data);
        setLoading(false);
        toast.success("Profit/Loss Report generated successfully");
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  //Function to get check out report
  const getCheckOutReport = () => {
    setLoading(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/report/get-checkout-report`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of getCheckOutReport: ", response.data);
        setCheckOutReport(response.data.data);
        setLoading(false);
        toast.success("Check out report generated successfully");
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (reportType === "Inmate Report") {
      getInmateReport();
    } else if (reportType === "Availability Report") {
      getAvailabilityReport();
    } else if (reportType === "Expense Report") {
      getExpenseReport();
    } else if (reportType === "Issue Report") {
      getIssueReport();
    } else if (reportType === "Payments Report") {
      getPaymentsReport();
    } else if (reportType === "Profit/Loss Report") {
      getProfitLossReport();
    } else if (reportType === "Checkout Report") {
      getCheckOutReport();
    } else {
      toast.error("Please select a report type");
    }
  }, [reportType]);

  //Function to handle download click
  const handleDownloadClick = () => {
    let tableData = [];
    if (reportType === "Inmate Report") {
      if (inmateReport?.length > 0) {
        tableData = inmateReport?.map((data) => ({
          "Building Name": data?.buildingName,
          "No. of Check-Ins": data?.checkInsCount,
          "No. of Bookings": data?.bookingsCount,
        }));
      } else {
        return toast.error("No data to export");
      }
    } else if (reportType === "Availability Report") {
      if (availabilityReport?.length > 0) {
        tableData = availabilityReport?.map((data) => ({
          "Building Name": data?.nameBuilding,
          "Total Floors": data?.totalFloors,
          "Total Rooms": data?.totalRooms,
          "Total Configured Rooms": data?.configuredRooms,
          "Total Beds": data?.totalBeds,
          "Vacant Beds": data?.vacantBeds,
          "Occupied Beds": data?.occupiedBeds,
          "Beds on Notice": data?.bedsOnNotice,
        }));
      } else if (reportType === "Payments Report") {
      } else {
        return toast.error("No data to export");
      }
    } else if (reportType === "Expense Report") {
      const titleRow = [[`Expense Report for Financial Year ${financialYear}`]];
      const headerRow = [
        [
          "Building Name",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
          "January",
          "February",
          "March",
        ],
      ];

      // Convert expense data to an array format
      const dataRows = expenseReport.map((expense) => [
        expense.buildingName,
        expense.April,
        expense.May,
        expense.June,
        expense.July,
        expense.August,
        expense.September,
        expense.October,
        expense.November,
        expense.December,
        expense.January,
        expense.February,
        expense.March,
      ]);
      tableData = [...titleRow, [], ...headerRow, ...dataRows];
    } else if (reportType === "Issue Report") {
      if (issueReport?.length > 0) {
        tableData = issueReport?.map((data) => ({
          "Building Name": data?.buildingName,
          "Total Issues": data?.totalIssues,
          "Resolved Issues": data?.resolvedIssues,
          "In Progress Issues": data?.inProgressIssues,
          "Invalidate Issues": data?.invalidatedIssues,
        }));
      }
    } else if (reportType === "Payments Report") {
      if (paymentsReport?.length > 0) {
        const headers = [
          "Building Name",
          "Month",
          "Total Rent Collected",
          "Total Electricity Collected",
          "Total Dues Collected",
        ];
        paymentsReport?.forEach((building) => {
          const buildingName = building.buildingName;
          Object.entries(building.monthlyPayments).forEach(([month, data]) => {
            tableData.push([
              buildingName,
              month,
              data.totalRentCollected,
              data.totalElectricityCollected,
              data.totalDuesCollected,
            ]);
          });
        });
        tableData.unshift(headers);
      } else {
        toast.error("No data to export");
      }
    } else if (reportType === "Profit/Loss Report") {
      if (profitLossReport?.length > 0) {
        const headers = [
          "Building Name",
          "Month",
          "Total Electricity",
          "Total Expenses",
          "Total Amount Collected",
          "Net Profit",
          "Status",
        ];
        profitLossReport.forEach((building) => {
          const buildingName = building.buildingName;
          Object.entries(building.monthlySummary).forEach(([month, data]) => {
            tableData.push([
              buildingName,
              month,
              data.totalElectricity,
              data.totalExpenses,
              data.totalAmountCollected,
              data.netProfit,
              data.netProfit > 0
                ? "Profit"
                : data.netProfit < 0
                ? "Loss"
                : "N/A",
            ]);
          });
        });
        tableData.unshift(headers);
      } else {
        toast.error("No data to export");
      }
    } else if (reportType === "Checkout Report") {
      if (checkOutReport?.length > 0) {
        tableData = checkOutReport?.map((data) => ({
          "Building Name": data?.buildingName,
          "No. of Check-Outs": data?.checkOutsCount,
        }));
      } else {
        return toast.error("No data to export");
      }
    } else {
      return toast.error("No data to export");
    }
    console.log("Table Data: ", tableData);
    exportToExcel(tableData, reportType);
  };

  const today = new Date();
  const currentMonth = today.getMonth();
  const currentYear = today.getFullYear();
  const year = `${currentMonth >= 3 ? currentYear : currentYear - 1}-${
    currentMonth >= 3
      ? (currentYear + 1).toString().slice(-2)
      : currentYear.toString().slice(-2)
  }`;

  return (
    <div className="expenseConatinaer p-6 bg-primarybgColor ">
      <h1 className="text-primaryTextColor text-[25px] sm:text-[32px] font-bold mb-6">
        Reports
      </h1>

      <div className="p-4  bg-white shadow-lg mt-6 rounded-lg overflow-hidden ">
        {/* Report Type  */}
        <div
          className="flex gap-2 justify-between
         items-center mt-2 mb-6"
        >
          <div>
            <h1 className="text-[18px] sm:text-[24px] font-bold ">
              {reportType}{" "}
              {(reportType === "Payments Report" ||
                reportType === "Expense Report" ||
                reportType === "Profit/Loss Report") &&
                `(${year})`}
            </h1>
          </div>

          <div className="flex justify-end gap-4">
            {/* Select Report Type  */}
            <select
              name="reportType"
              id="reportType"
              className="border border-gray-300  rounded-lg p-2 text-primaryTextColor focus:outline-none focus:ring focus:ring-blue-200"
              onChange={(e) => {
                setReportType(e.target.value);
              }}
            >
              <option value="Inmate Report">Inmate Report</option>
              <option value="Availability Report">Availability Report</option>
              <option value="Payments Report">Payments Report</option>
              <option value="Profit/Loss Report">Profit/Loss Report</option>
              <option value="Checkout Report">Checkout Report</option>
              <option value="Expense Report">Expense Report </option>
              <option value="Issue Report">Issue Report </option>
            </select>
            {reportType && (
              <MdDownloadForOffline
                title="Download Data"
                className="text-primaryColor  rounded-lg cursor-pointer"
                size={46}
                color="#2196f3"
                onClick={handleDownloadClick}
              />
            )}
          </div>
        </div>

        <div className="overflow-x-auto min-h-[70vh]">
          {loading ? (
            <div className="fixed inset-0  h-screen w-screen flex items-center justify-center bg-black bg-opacity-50">
              <span class="loader"></span>
            </div>
          ) : (
            <div>
              {reportType === "Inmate Report" ? (
                <InmateReport inmateReport={inmateReport} />
              ) : reportType === "Availability Report" ? (
                <AvailabilityReport availabilityReport={availabilityReport} />
              ) : reportType === "Expense Report" ? (
                <ExpenseReport expenseReport={expenseReport} />
              ) : reportType === "Issue Report" ? (
                <IssueReport issueReport={issueReport} />
              ) : reportType === "Payments Report" ? (
                <PaymentsReport paymentsReport={paymentsReport} />
              ) : reportType === "Checkout Report" ? (
                <CheckOutReport checkOutReport={checkOutReport} />
              ) : reportType === "Profit/Loss Report" ? (
                <div className="py-40 px-6 text-lg text-center text-secondaryTextColor">
                  <p>Too large to show. Please download</p>
                </div>
              ) : null}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Reports;
